import { ReactNode } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import AlertMessage from "../../../components/AlertMessage";
import { GenericSaveButton } from "../../../components/common/GenericSaveButton";
import { useTranslation } from "react-i18next";
import { AlertType } from "../../../hooks/useAlert";

interface AlertDetailScaffoldProps {
    loading: boolean;
    editing: boolean;
    isVisible: boolean;
    alert?: {
        message: string;
        type: AlertType;
    } | null;
    onHideAlert: () => void;
    onEditClick: () => void;
    onBackClick: () => void;
    onSaveClick: () => void;
    saveDisabled?: boolean;
    children: ReactNode;
}

export default function AlertDetailWrapper({
    loading,
    editing,
    isVisible,
    alert,
    onHideAlert,
    onEditClick,
    onBackClick,
    onSaveClick,
    saveDisabled = false,
    children,
}: AlertDetailScaffoldProps) {
    const { t } = useTranslation(["common"]);

    return (
        <div className="container-fluid">
            {loading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
            <Row>
                <Col className="text-center" xs={12} md={12}>
                    {isVisible && alert && (
                        <AlertMessage
                            message={alert.message}
                            type={alert.type}
                            onClose={onHideAlert}
                        />
                    )}
                </Col>
            </Row>
            {!editing && (
                <Row className="mb-3">
                    <Col xs={12} md={12} className="text-end">
                        <GenericSaveButton
                            onClick={onEditClick}
                            onCancelClick={onBackClick}
                            cancelLabel={t("common:buttons.buttonBack")}
                            saveLabel={t("common:buttons.buttonEdit")}
                        />
                    </Col>
                </Row>
            )}
            {editing && (
                <Row className="mb-3">
                    <Col className="text-end">
                        <GenericSaveButton
                            onClick={onSaveClick}
                            onCancelClick={onBackClick}
                            disabled={saveDisabled}
                        />
                    </Col>
                </Row>
            )}
            {children}
        </div>
    );
}
